import styled from 'styled-components';
import {
  buttonAsLinkReset,
  focusOutline,
  linkWithoutVisited,
  safeFocusRemoval,
  svg,
  text_s,
  hideOnPrint,
  iconColorOnPrint
} from '../../../styles';

export const Button = styled.button`
  ${buttonAsLinkReset}
  ${linkWithoutVisited}
  &:focus {
    ${safeFocusRemoval}
    ${focusOutline}
  }
  ${text_s}
  padding-right: 4px;
  margin: 0;
  ${hideOnPrint}
`;

export const ArrowWrapper = styled.span`
  ${svg(7, 12)}
  margin-left: 8px;
  width: 7px;
  transform: rotate(90deg);

  ${Button}:focus &,
  ${Button}:hover & {
    path {
      fill: ${({ theme }) => theme.colors.element.white};
      ${iconColorOnPrint}
    }
  }

  path {
    fill: ${({ theme }) => theme.colors.element.primary};
  }
`;
